import React, { useState } from 'react';
import { Select as AntSelect, Tooltip } from 'antd';
import { Select, Detail, Radio, Icon } from 'components/common';
import { Token } from 'components/common/TokenInput';
import { colours } from 'utils/theme';
import licenseType from 'models/licenseType';
import { frequencyOptions, frequencyRadioOptions } from 'models/frequency';
import { useAuth } from 'hooks';
import {
  StyledIcon,
  SharedAlertPanel,
  SharedAlertHeader,
  SharedAlertHeaderTitle,
  SharedAlertContainer,
  SharedAlertInfo,
  SharedAlertWarning,
} from '../styled';
import { missingPurchasingAlertLicenseTooltip } from '../constants';

const { Option } = AntSelect;

const getLicenseIcons = licenses => {
  const hasAcademic = licenses.some(x => licenseType.academic === x.type);
  const hasIndustry = licenses.some(x => licenseType.industry === x.type);
  const hasLegacy = licenses.some(x => licenseType.legacy === x.type);
  return (
    <>
      {hasAcademic && (
        <Icon
          icon='book'
          size='sm'
          style={{ marginRight: '5px' }}
          color='inherit'
        />
      )}
      {hasIndustry && (
        <Icon
          icon='company'
          size='sm'
          style={{ marginRight: '5px' }}
          color='inherit'
        />
      )}
      {hasLegacy && (
        <Icon
          icon='image'
          size='sm'
          style={{ marginRight: '5px' }}
          color='inherit'
        />
      )}
    </>
  );
};

const renderUsers = (o, i) => (
  <Option
    title={o.fullname}
    key={`${o.fullname}-${i}`}
    value={o.userId}
    data-testid={`$alert-user-option-${i}`}
    details={o.fullname}
    label={o.fullname}
    disabled={o.missingPurchasingAlertLicense}
  >
    <Tooltip
      title={
        o.missingPurchasingAlertLicense
          ? missingPurchasingAlertLicenseTooltip
          : ''
      }
      overlayStyle={{ maxWidth: 450 }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {getLicenseIcons(o.licenses)}
        {o.fullname}
      </div>
    </Tooltip>
  </Option>
);

const tagRender = props => {
  const { label, onClose } = props;
  const hasActiveLicense = typeof label !== 'string';
  const onPreventMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tooltip
      title={hasActiveLicense ? '' : 'User does not have any active licenses'}
    >
      <Token
        key={label}
        value={label}
        removeToken={onClose}
        style={{ marginTop: '2px', marginBottom: '2px' }}
        onMouseDown={onPreventMouseDown}
        background={
          hasActiveLicense ? colours.inlcudeFilter : colours.excludeFilter
        }
      />
    </Tooltip>
  );
};

const Share = ({
  userOptions,
  activeAlert,
  sharedUsers,
  handleUsersChange,
  showWarning,
  loading,
  handleChildAlertChange,
  disabled,
}) => {
  const { user } = useAuth();
  const [showOptions, setShowOptions] = useState(false);

  if (
    !user.isUserManager ||
    !userOptions?.length ||
    !activeAlert.structuredSearch
  ) {
    return null;
  }
  return (
    <SharedAlertContainer>
      <SharedAlertHeader
        onClick={() => !disabled && setShowOptions(!showOptions)}
        style={disabled ? { cursor: 'not-allowed', opacity: 0.7 } : {}}
      >
        <div>
          <SharedAlertHeaderTitle>Share</SharedAlertHeaderTitle>
          <div>
            Search for members of your team below to share this item with
          </div>
        </div>
        <StyledIcon
          icon='chevronDown'
          color={colours.grey}
          active={showOptions}
          size='sm'
        />
      </SharedAlertHeader>
      <SharedAlertPanel style={{ display: showOptions ? 'flex' : 'none' }}>
        <SharedAlertInfo>
          <Icon icon='circleInfo' color={colours.linkBlue} size='1x' />
          <div style={{ fontSize: '12px' }}>
            Please refer to the Shared Alerts FAQ for more information.
          </div>
        </SharedAlertInfo>
        <Select
          mode='multiple'
          style={{ width: '100%' }}
          value={sharedUsers}
          options={userOptions}
          optionFilterProp='label'
          optionLabelProp='children'
          tagRender={tagRender}
          renderOption={renderUsers}
          onChange={handleUsersChange}
          disabled={disabled || loading}
        />
        {showWarning && (
          <SharedAlertWarning>
            <Icon icon='circleInfo' color='#FAAD14' size='1x' />
            {showWarning}
          </SharedAlertWarning>
        )}
        {!user.disableExport && (
          <Detail>
            <Radio
              radioStyle={{ height: '30px', lineHeight: '30px' }}
              value={activeAlert.childAlert?.frequencyRadio}
              onChange={handleChildAlertChange('frequencyRadio')}
              options={frequencyRadioOptions}
              disabled={disabled || loading}
            />
            <Select
              disabled={
                disabled ||
                loading ||
                activeAlert.childAlert?.frequencyRadio !== 'Alert'
              }
              value={activeAlert.childAlert?.frequency}
              onChange={handleChildAlertChange('frequency')}
              options={frequencyOptions}
              style={{ minWidth: '95px' }}
            />
          </Detail>
        )}
      </SharedAlertPanel>
    </SharedAlertContainer>
  );
};

export default Share;
